import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequiredValidator } from 'src/app/shared/validators/required.validator';
import { InvoiceService } from '../../../services/invoice.service';
import { GreaterThanZeroValidator } from 'src/app/shared/validators/greater-than-zero.validators';
import { TEAValidation } from 'src/app/shared/validators/tea-value.validators';
import { AmountValidator } from 'src/app/shared/validators/amount.validator';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.states';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-invoice-tea-configuration-dialog',
  templateUrl: './invoice-tea-configuration-dialog.component.html',
  styleUrls: ['./invoice-tea-configuration-dialog.component.scss'],
})
export class InvoiceTeaConfigurationDialogComponent implements OnInit {
  form: FormGroup;
  direction = 'column';
  _selectedValue;
  invoices = [];
  invoice;
  isTeaSelected = false;

  constructor(
    public dialogRef: MatDialogRef<InvoiceTeaConfigurationDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _service: InvoiceService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.invoice = this.data.invoice;

    if (this.invoice?.status === 'awaiting collection') {
      this.invoices = [{ ...this.invoice, selected: true }];
    } else {
    const filters = {
      debtor: this.invoice.debtor._id,
      currency: this.invoice.currency,
      isConfirming: this.invoice.isConfirming,
      statuses: ['pending confirmation', 'configured'],
    };

    this._service.getGroupInvoice(filters, null).subscribe((result: any) => {
      this.invoices = result.entities;

      this.invoices.sort((a, b) => {
        if (String(a._id) === String(this.invoice._id)) return -1;
        if (String(b._id) === String(this.invoice._id)) return 1;
        return 0;
      });

      this.invoices.find(i => String(i._id) === String(this.invoice._id)).selected = true;
    });
    }

    this.store.select(UsersSelectors.profileProperty('role')).pipe(take(1)).subscribe(role => {
      if (role === 'investor sales supervisor' || role === 'investor sales') {
        this.form = this.formBuilder.group({
          tea: ['', [RequiredValidator, AmountValidator, GreaterThanZeroValidator, TEAValidation(30)]],
        });
      } else {
        this.form = this.formBuilder.group({
          tea: ['', [RequiredValidator, AmountValidator, GreaterThanZeroValidator, TEAValidation(18)]],
        });
      }
      this.form.controls['tea'].setValue(this.invoice.tea);
    });
  }

  onSubmit() {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      let result = {
        teaPercentage: this.form.controls['tea'].value,
        codes: this.invoices
          .filter(invoice => invoice.selected)
          .map(invoice => {
            return String(invoice._id);
            // return {
            //   _id: String(invoice._id),
            // };
          })
          .join(','),
        _id: String(this.invoice._id),
      };
      this.dialogRef.close(result);
    }
  }

  continue() {
    this.isTeaSelected = true;
  }

  goBack() {
    this.isTeaSelected = false;
  }

  cancel() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  getCodes(invoice) {
    return invoice.physicalInvoices.map(i => i.code).join('\n');
  }

  selectAll(event?: any) {
    // Get the checked state from the event if available, otherwise toggle based on current state
    const shouldSelectAll = event?.checked !== undefined ? event.checked : !this.isAllChecked();

    if (shouldSelectAll) {
      // Select all invoices
      this.invoices.forEach(invoice => (invoice.selected = true));
    } else {
      // Deselect all except the first one (which is disabled and should always remain selected)
      this.invoices.forEach((invoice, index) => {
        if (index === 0) {
          invoice.selected = true; // Keep first invoice selected (disabled)
        } else {
          invoice.selected = false;
        }
      });
    }

    // Force change detection to update the UI
    this.cdr.detectChanges();
  }

  isSomeChecked(): boolean {
    const selectableInvoices = this.invoices.slice(1); // Exclude first disabled invoice
    if (selectableInvoices.length === 0) {
      return false; // No selectable invoices, so no indeterminate state
    }
    const allSelected = selectableInvoices.every(i => i.selected);
    const someSelected = selectableInvoices.some(i => i.selected);
    return someSelected && !allSelected;
  }

  isAllChecked() {
    // Check if all selectable invoices (excluding the disabled first one) are selected
    const selectableInvoices = this.invoices.slice(1); // Exclude first disabled invoice
    if (selectableInvoices.length === 0) {
      return true; // No selectable invoices, consider all checked
    }
    return selectableInvoices.every(i => i.selected);
  }

  setSelection(invoice) {
    this.invoices.find(inv => String(inv._id) === String(invoice._id)).selected = !this.invoices.find(
      inv => String(inv._id) === String(invoice._id)
    ).selected;

    // Force change detection to update the UI
    this.cdr.detectChanges();
  }

  propagateChange = (_: any) => {};
}
